import { isModelAssetType } from '@/lib/modelPresets.js'

/**
 * Resolves the active 3D model asset for a floor using the precedence:
 *   floor.assets > building.assets > site.assets
 *
 * Each layer is searched for a supported 3D model asset; the first match wins.
 * The returned asset is annotated with `source` ('floor' | 'building' | 'site')
 * so callers can render badges or pick different transform behaviors.
 */
export function resolveModelAsset(floor) {
  if (!floor) return null
  const layers = [
    { source: 'floor', list: floor.assets },
    { source: 'building', list: floor.building?.assets },
    { source: 'site', list: floor.site?.assets },
  ]
  for (const { source, list } of layers) {
    if (!Array.isArray(list)) continue
    const asset = list.find((a) => isModelAssetType(a?.asset_type))
    if (asset) return { ...asset, source }
  }
  return null
}

export function hasFloorOverride(floor) {
  return (floor?.assets || []).some((a) => isModelAssetType(a?.asset_type))
}
